import React from 'react'

import cn from 'classnames/bind'
import {useRouter} from 'next/router'

import ErrorPageContent from 'components/blocks/ErrorPageContent'
import Button from 'components/elements/Button'
import {Container, Row, Col} from 'components/elements/grid'
import {TPageComponent} from 'src/types'

import s from './ErrorBoundaryFallback.module.scss'
const cx = cn.bind(s)

interface ITemplateProps {
	className?: string
}

const ErrorBoundaryFallback: TPageComponent<ITemplateProps> = ({className}) => {
	const router = useRouter()

	const GoToHomeBtn = () => {
		return (
			<Button size="big" onClick={() => router.push('/')}>
				Go to home
			</Button>
		)
	}

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<div className={cx('wrapper-inner')}>
					<Row>
						<Col md={{span: 10}} lg={{span: 8}} xl={{offset: 1, span: 8}}>
							<ErrorPageContent
								title="Oh no!"
								subtitle="Something went wrong"
								description="Our development team is already fixing this problem."
								button={<GoToHomeBtn />}
								className={cx('error-content')}
							/>
						</Col>
					</Row>
				</div>
			</Container>
		</div>
	)
}

ErrorBoundaryFallback.displayName = 'ErrorBoundaryFallback'

export default ErrorBoundaryFallback
